import { createAction } from "redux-actions";

//Reset product status
export const REQUESTED_RESET_PRODUCT_STATUS = "REQUESTED_RESET_PRODUCT_STATUS";

// Get product
export const REQUESTED_PRODUCTS = "REQUESTED_PRODUCTS";
export const RECEIVED_PRODUCTS = "RECEIVED_PRODUCTS";
export const REQUESTED_PRODUCT_BY_NAME = "REQUESTED_PRODUCT_BY_NAME";
export const RECEIVED_PRODUCT_BY_NAME = "RECEIVED_PRODUCT_BY_NAME";
export const REQUESTED_PRODUCT_BY_ID = "REQUESTED_PRODUCT_BY_ID";
export const RECEIVED_PRODUCT_BY_ID = "RECEIVED_PRODUCT_BY_ID";
export const REQUESTED_SELECT_PRODUCT = "REQUESTED_SELECT_PRODUCT";
export const RECEIVED_SELECT_PRODUCT = "RECEIVED_SELECT_PRODUCT";
export const REQUESTED_PRODUCT_PHASES = "REQUESTED_PRODUCT_PHASES";
export const RECEIVED_PRODUCT_PHASES = "RECEIVED_PRODUCT_PHASES";
export const REQUESTED_PRODUCT_PHASES_BY_NAME =
  "REQUESTED_PRODUCT_PHASES_BY_NAME";
export const RECEIVED_PRODUCT_PHASES_BY_NAME =
  "RECEIVED_PRODUCT_PHASES_BY_NAME";

export const REQUESTED_CURRENT_PRODUCT_FAILED = "REQUESTED_CURRENT_PRODUCT_FAILED";

export const requestProducts = createAction(REQUESTED_PRODUCTS);
export const receiveProducts = createAction(RECEIVED_PRODUCTS, (products) => ({
  products,
}));

export const requestProductByName = createAction(
  REQUESTED_PRODUCT_BY_NAME,
  (name) => name
);
export const receiveProductByName = createAction(
  RECEIVED_PRODUCT_BY_NAME,
  (product) => ({
    product,
  })
);

export const requestProductById = createAction(
  REQUESTED_PRODUCT_BY_ID,
  (id) => id
);
export const receiveProductById = createAction(
  RECEIVED_PRODUCT_BY_ID,
  (product) => ({
    product,
  })
);

export const requestSelectProduct = createAction(REQUESTED_SELECT_PRODUCT);
export const receiveSelectProduct = createAction(
  RECEIVED_SELECT_PRODUCT,
  (selectedProducts) => ({
    selectedProducts,
  })
);

export const requestProductPhases = createAction(
  REQUESTED_PRODUCT_PHASES,
  (productsMap) => productsMap
);
export const receiveProductPhases = createAction(
  RECEIVED_PRODUCT_PHASES,
  (name, phaseList) => ({
    name,
    phaseList,
  })
);

export const requestProductPhasesByName = createAction(
  REQUESTED_PRODUCT_PHASES_BY_NAME,
  (name) => name
);
export const receiveProductPhasesByName = createAction(
  RECEIVED_PRODUCT_PHASES_BY_NAME,
  (name, phaseList) => ({
    name,
    phaseList,
  })
);

// Create product
export const REQUESTED_CREATE_PRODUCT = "REQUESTED_CREATE_PRODUCT";
export const RECEIVED_CREATE_PRODUCT = "RECEIVED_CREATE_PRODUCT";

export const requestCreateProduct = createAction(
  REQUESTED_CREATE_PRODUCT,
  (product) => ({
    product,
  })
);
export const receiveCreateProduct = createAction(
  RECEIVED_CREATE_PRODUCT,
  (product) => ({
    product,
  })
);

// Update product
export const REQUESTED_UPDATE_PRODUCT = "REQUESTED_UPDATE_PRODUCT";
export const RECEIVED_UPDATE_PRODUCT = "RECEIVED_UPDATE_PRODUCT";

export const requestUpdateProduct = createAction(
  REQUESTED_UPDATE_PRODUCT,
  (product) => ({
    product,
  })
);
export const receiveUpdateProduct = createAction(
  RECEIVED_UPDATE_PRODUCT,
  (product) => ({
    product,
  })
);

// Update product's versions
export const REQUESTED_UPDATE_PRODUCT_VERSIONS =
  "REQUESTED_UPDATE_PRODUCT_VERSIONS";
export const RECEIVED_UPDATE_PRODUCT_VERSIONS =
  "RECEIVED_UPDATE_PRODUCT_VERSIONS";

export const requestUpdateProductVersions = createAction(
  REQUESTED_UPDATE_PRODUCT_VERSIONS,
  (product) => ({
    product,
  })
);
export const receiveUpdateProductVersions = createAction(
  RECEIVED_UPDATE_PRODUCT_VERSIONS,
  (product) => ({
    product,
  })
);

// Update product's phases
export const REQUESTED_UPDATE_PRODUCT_PHASES =
  "REQUESTED_UPDATE_PRODUCT_PHASES";
export const RECEIVED_UPDATE_PRODUCT_PHASES = "RECEIVED_UPDATE_PRODUCT_PHASES";

export const requestUpdateProductPhases = createAction(
  REQUESTED_UPDATE_PRODUCT_PHASES,
  (product) => ({
    product,
  })
);
export const receiveUpdateProductPhases = createAction(
  RECEIVED_UPDATE_PRODUCT_PHASES,
  (product) => ({
    product,
  })
);

// Delete product
export const REQUESTED_DELETE_PRODUCT = "REQUESTED_DELETE_PRODUCT";
export const RECEIVED_DELETE_PRODUCT = "RECEIVED_DELETE_PRODUCT";

export const requestDeleteProduct = createAction(
  REQUESTED_DELETE_PRODUCT,
  (product) => ({
    product,
  })
);
export const receiveDeleteProduct = createAction(
  RECEIVED_DELETE_PRODUCT,
  (product) => ({
    product,
  })
);
